import { FC, useState } from "react";
import { Heading } from "@otrium/atoms";
import { Box, Flex } from "@otrium/core";
import { Modal } from "src/atoms/Modal";
import { useStorefrontCollections } from "src/hooks/useStorefrontCollections";
import {
  StyledAddToCollection,
  StyledButton,
  StyledInfoHeader,
} from "./AddToCollectionModal.styled";
import { AddToCollectionCheckbox } from "src/organisms/AddToCollection/AddToCollectionCheckbox";
import { AddToStorefrontCheckbox } from "src/organisms/AddToCollection/AddToStorefrontCheckbox";
import { CollectionSelect } from "src/organisms/AddToCollection/CollectionSelect";
import { SaveCollectionButton } from "src/organisms/AddToCollection/SaveCollectionButton";
import { CloseButton } from "src/atoms/CloseButton";

export interface Collection {
  id: string;
  name: string;
}
interface Props {
  productsIds: number[];
}

const AddToCollectionModal: FC<Props> = ({ productsIds }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCollection, setSelectedCollection] = useState("");
  const [shouldAddToStorefront, setShouldAddToStorefront] = useState(false);
  const [shouldAddToCollection, setShouldAddToCollection] = useState(false);

  const {
    collections,
    loading: collectionsLoading,
  }: {
    collections: Collection[];
    loading: boolean;
  } = useStorefrontCollections();

  if (collectionsLoading || !collections) {
    return null;
  }

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return (
    <div suppressHydrationWarning>
      <Modal isOpen={isOpen} onClose={close} withHeader overFlow="visible">
        <StyledAddToCollection>
          <CloseButton
            onClick={close}
            sx={{ position: "absolute", right: "10px", top: "10px" }}
          />
          <StyledInfoHeader>
            <Heading as="h3" variant="h3" textAlign="center">
              Select collection
            </Heading>
          </StyledInfoHeader>

          <Box py={3}>
            <CollectionSelect
              collections={collections}
              selectedCollection={selectedCollection}
              setSelectedCollection={setSelectedCollection}
            />
          </Box>
          {selectedCollection && (
            <>
              <Flex flexDirection="column" pb={3}>
                <AddToStorefrontCheckbox
                  shouldAddToStorefront={shouldAddToStorefront}
                  setShouldAddToStorefront={setShouldAddToStorefront}
                />
                <AddToCollectionCheckbox
                  shouldAddToCollection={shouldAddToCollection}
                  setShouldAddToCollection={setShouldAddToCollection}
                />
              </Flex>
              <SaveCollectionButton
                close={close}
                selectedCollection={selectedCollection}
                shouldAddToStorefront={shouldAddToStorefront}
                shouldAddToCollection={shouldAddToCollection}
                productsIds={productsIds}
              />
            </>
          )}
        </StyledAddToCollection>
      </Modal>
      <StyledButton variant="secondary" onClick={open}>
        Add to collection
      </StyledButton>
    </div>
  );
};

export default AddToCollectionModal;
